<template>
  <form @submit.prevent="save_event" class="mt-8">

    <h4 class="mt-8">{{ $t('MEMBER_PROPERTY.QUESTIONEER') }}</h4>
      <p style="font-style: italic;">{{ $t('MEMBER_PROPERTY.QUESTIONEER_INFO') }}</p>
      <AttributeGroupSelectButton
        :group_ids="local_item.group_ids"
        @selected="property_groups_selected"
      />
      <p class="mt-4"><a href="/ml-properties">{{ $t('MEMBER_PROPERTY.ADMINISTER') }} >></a></p>

  </form>
</template>

<script>
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import axios from 'axios';
import AttributeGroupSelectButton from '@/view/components/attribute_group_selector/AttributeGroupSelectButton.vue';

export default {
  props: ['item'],
  mixins: [ toasts ],
  components: {
    AttributeGroupSelectButton
  },
  
  watch: {
    
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_item = JSON.parse(JSON.stringify(this.item));
      },
      immediate: true
    },

  },
  methods: {
    save_event() {},

    property_groups_selected(group_ids) {
      this.local_item.group_ids = group_ids;
      this.local_item = { ...this.local_item }

      this.$emit('change', this.local_item);
    },
    on_change() {
      console.log('form has changed', this.local_item)
      this.$emit('change', this.local_item);
    }
  },
  data() {
    return {
      local_item: {}
    }
  },
}
</script>
